import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DocumentsComponent} from "./documents.component";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {FileSizeModule} from "@app/pipes/file-size/file-size.module";
import {DisplayDateModule} from "@app/pipes/display-date/display-date.module";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {FormsModule} from "@angular/forms";
import {DocumentDialogComponent} from "@app/pages/documents/document-dialog/document-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import { DocumentDeleteComponent } from './document-delete/document-delete.component';

@NgModule({
    declarations: [DocumentsComponent, DocumentDialogComponent, DocumentDeleteComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatRadioModule,
        MatDatepickerModule,
        MatInputModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        DisplayDateModule,
        FileSizeModule,
        MatButtonToggleModule,
        FormsModule,
        MatDialogModule,
        LogPipeModule,
        MatSelectModule,
        MatCheckboxModule
    ]
})
export class DocumentsModule {
}
